import { useState, useMemo } from 'react';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function getInitialValuesFromFields(fields) {
    return Object.keys(fields).reduce(function(result, fieldName) {
        var _fields_fieldName;
        var _fields_fieldName_startValue;
        return _object_spread_props(_object_spread({}, result), _define_property({}, fieldName, (_fields_fieldName_startValue = (_fields_fieldName = fields[fieldName]) === null || _fields_fieldName === void 0 ? void 0 : _fields_fieldName.startValue) !== null && _fields_fieldName_startValue !== void 0 ? _fields_fieldName_startValue : undefined));
    // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
    }, {});
}
function getErrors(fields, values) {
    return Object.keys(fields).reduce(function(errors, fieldName) {
        var field = fields[fieldName];
        if (field == null) return errors;
        var validations = field.validations, skipValidationsCondition = field.skipValidationsCondition;
        if (skipValidationsCondition === null || skipValidationsCondition === void 0 ? void 0 : skipValidationsCondition(values)) return errors;
        var value = values[fieldName];
        var fieldErrors = Object.keys(validations).reduce(function(fieldsErrors, validationName) {
            var _validation_skipCondition;
            var validation = validations[validationName];
            if (validation == null) return fieldsErrors;
            var testFunction = validation.test;
            if (!((_validation_skipCondition = validation.skipCondition) === null || _validation_skipCondition === void 0 ? void 0 : _validation_skipCondition.call(validation, values)) && !testFunction(value, values)) {
                return _object_spread_props(_object_spread({}, fieldsErrors), _define_property({}, validationName, validation.errorMessage));
            }
            return fieldsErrors;
        }, {});
        if (Object.keys(fieldErrors).length > 0) {
            return _object_spread_props(_object_spread({}, errors), _define_property({}, fieldName, fieldErrors));
        }
        return errors;
    }, {});
}
function getEnabled(fields, errors) {
    var fieldWithValidationThatDisablesForm = Object.keys(errors).find(function(fieldWithError) {
        var field = fields[fieldWithError];
        var error = errors[fieldWithError];
        if (error == null || field == null) return false;
        var validationThatDisablesForm = Object.keys(error).find(function(failedValidation) {
            var _field_validations_failedValidation;
            var someFailedValidationDisablesForm = (_field_validations_failedValidation = field.validations[failedValidation]) === null || _field_validations_failedValidation === void 0 ? void 0 : _field_validations_failedValidation.disablesForm;
            return someFailedValidationDisablesForm === true;
        });
        return validationThatDisablesForm != null;
    });
    return fieldWithValidationThatDisablesForm == null;
}
/**
 * @deprecated
 * Please don't use this function anymore.
 * reach out to #feds for alternatives.
 */ // Creates an ordinary validation object to be used by on of the form fields
var basicRequiredValidation = {
    errorMessage: "",
    disablesForm: true,
    test: function(value) {
        // ? TO ASK: how does it reference to field's value?
        if (typeof value === "string" || Array.isArray(value)) {
            return value.length > 0;
        } else {
            return value != null;
        }
    }
};
/**
 * @deprecated
 * Please don't use this hook anymore.
 * reach out to #feds for alternatives.
 */ var useForm = function(param) {
    var fields = param.fields;
    var reset = function reset() {
        setValuesInternal(getInitialValuesFromFields(fields));
    };
    var setValue = function setValue(key, value) {
        setValuesInternal(function(state) {
            return _object_spread_props(_object_spread({}, state), _define_property({}, key, value));
        });
    };
    var setValues = function setValues(fieldsValues) {
        setValuesInternal(function(state) {
            return _object_spread({}, state, fieldsValues);
        });
    };
    var _useState = _sliced_to_array(useState(getInitialValuesFromFields(fields)), 2), values = _useState[0], setValuesInternal = _useState[1];
    var errors = useMemo(function() {
        return getErrors(fields, values);
    }, [
        fields,
        values
    ]);
    var enabled = useMemo(function() {
        return getEnabled(fields, errors);
    }, [
        errors,
        fields
    ]);
    var valid = Object.keys(errors).length === 0;
    return {
        reset: reset,
        setValue: setValue,
        setValues: setValues,
        values: values,
        valid: valid,
        enabled: enabled,
        errors: errors
    };
};

export { basicRequiredValidation, useForm };
